import vuetify from '@/main';
import { defineAsyncComponent } from 'vue';
angular.module('leanlaw').config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
  $stateProvider.state('billing', {
    url: '/billing/{clientId}/{matterId}',
    template: require('./views/billing.html'),
    controller: 'BillingCtrl',
    redirectTo: 'billing.invoice.summary',
    params: {
      reload: false
    }
  }).state('billing.invoiceInsights', {
    url: '/invoice-insights',
    views: {
      '': {
        ...vuetify(defineAsyncComponent(() => import('@/modules/insights/InvoiceInsights.vue')))
      }
    }
  }).state('billing.upgradePlan', {
    url: '/upgrade-plan',
    views: {
      '': {
        ...vuetify(defineAsyncComponent(() => import('@/modules/reports/SubscriptionUpgrade/SplashPage.vue')))
      }
    }
  });
}]);